import { render, staticRenderFns } from "./modalRevisi.vue?vue&type=template&id=02fd5d5c&scoped=true"
import script from "./modalRevisi.vue?vue&type=script&lang=js"
export * from "./modalRevisi.vue?vue&type=script&lang=js"
import style0 from "./modalRevisi.vue?vue&type=style&index=0&id=02fd5d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fd5d5c",
  null
  
)

export default component.exports